import {getEnv} from "./environment";

export const systemHost = getEnv(`REACT_APP_SYSTEM_HOST`);
export const systemConfig = {
  host: systemHost,
  baseUrl: systemHost,
};
